import React from 'react';

import { ICONS, Icon } from '../invoices/kit';
import { FEEDBACK_ICONS } from './icons';

/**
 * The two decisions that should be made at a glance.
 *
 * Both were three identical grey rectangles, which made picking a kind
 * and picking a severity feel like reading rather than choosing. Now each
 * card carries its own mark and its own colour, and the selected one
 * says so three ways at once -- fill, border and a tick -- so it never
 * rests on colour alone.
 *
 * Impact gets bars instead of an icon. Severity is a scale, and a scale
 * is a thing you should be able to see the shape of without reading the
 * words.
 */

function Meter({ level, tone }) {
  return (
    <span className={`fb-meter fb-meter--${tone}`} aria-hidden="true">
      {[1, 2, 3].map((bar) => (
        <span key={bar} className={`fb-meter__bar${bar <= level ? ' fb-meter__bar--on' : ''}`} />
      ))}
    </span>
  );
}

export default function Choices({ legend, name, choices, value, onChange, error, meter }) {
  return (
    <fieldset className="fb-group">
      <legend className="fb-group__legend">{legend}</legend>
      <div className="fb-choices" role="group">
        {choices.map((choice, index) => {
          const on = value === choice.id;
          return (
            <button
              key={choice.id}
              type="button"
              className={`fb-choice fb-choice--${choice.tone}`}
              aria-pressed={on}
              onClick={() => onChange(name, choice.id)}
            >
              <span className="fb-choice__top">
                {meter ? (
                  <Meter level={choices.length - index} tone={choice.tone} />
                ) : (
                  <span className="fb-choice__icon">
                    <Icon path={FEEDBACK_ICONS[choice.id]} size={17} />
                  </span>
                )}
                {on ? (
                  <span className="fb-choice__tick">
                    <Icon path={ICONS.check} size={11} />
                  </span>
                ) : null}
              </span>
              <span className="fb-choice__label">{choice.label}</span>
              <span className="fb-choice__hint">{choice.prompt}</span>
            </button>
          );
        })}
      </div>
      {error ? <span className="iv-hint iv-hint--error">{error}</span> : null}
    </fieldset>
  );
}
